// Act on each item in turn and keep going past a failure, so one member that
// cannot be written neither undoes nor hides the ones that were (M181). Returns
// the items that went through and, for each that did not, the item with its error.
export async function settleEach(items, act) {
  const done = [];
  const failed = [];
  for (const item of items) {
    try {
      await act(item);
      done.push(item);
    } catch (error) {
      failed.push({ item, error });
    }
  }
  return { done, failed };
}

// "X (reason); Y (reason)" for a summary line.
export const describeFailures = (failed, nameOf) => failed
  .map(({ item, error }) => `${nameOf(item)} (${error?.message || error})`)
  .join('; ');
